import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';

import { TranslateDirective } from '../../../../directives/translate.directive';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';

import { OptionFilterPipe } from '../../../pipes/option-filter.pipe';

import { BaryComponentHelper } from '../../util/bary-component-helper';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-input-select',
  templateUrl: './bary-input-select.component.html',
  styleUrls: ['./bary-input-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputUtilitiesModule,
    InputsModule,
    MDBBootstrapModulesPro,
    TranslateDirective,
    MarkAsteriskDirective,
    OptionFilterPipe,
    BaryIconComponent,
  ],
})
export class BaryInputSelectComponent implements OnInit {
  @Input() public id: string = BaryComponentHelper.makeId();
  @Input() public label: string = '';
  @Input() public hasFilter: boolean = false;
  @Input() public name?: string;
  @Input() public placeholder?: string;
  @Input() public disabled = false;
  @Input() public options: Array<{ label: string; value: any }> = [];
  @Input() public optionsWithMdbIcons!: Array<{ label: string; value: any; mdbIcons: any }>;
  @Input() public withMdbIcons: boolean = false;
  @Input() public control = new FormControl('');

  @Output() public selectEvent = new EventEmitter();

  public selectControlFilter = new FormControl('');

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    this.control.valueChanges.subscribe(val => this.selectEvent.emit(val));
  }
}
